// Team accounts: see the founder dashboard.
// Keep in sync with FOUNDER_EMAILS in backend/config.py.
export const FOUNDER_EMAILS = [
  "dmenezes16@gmail.com",
  "deborah@langcraft.world",
  "johnjoykurian@gmail.com",
];

export const isFounderEmail = (email) =>
  FOUNDER_EMAILS.includes((email || "").trim().toLowerCase());
